import { useMemo } from "react";

import { formatSignedPctNumber } from "../../lens-stats/formatters";
import { formatDAUValue } from "../formatters";

export const useWAUMAUCalculations = (dauValue: number, dauPrevValue: number): { value: string; diffValue: string } =>
    useMemo(() => {
        const diffValue = ((dauValue - dauPrevValue) * 100).toFixed(2);

        return {
            value: formatDAUValue(dauValue),
            diffValue: dauPrevValue > 0 ? formatSignedPctNumber(diffValue.toString()) : "",
        };
    }, [dauValue, dauPrevValue]);
